<template>
  <div>
    <el-form :model="editPwdObj" style="width: 500px;margin: 30px auto;">
      <el-form-item label="新密码">
        <el-input show-password v-model="editPwdObj.oprPwd"></el-input>
      </el-form-item>
      <el-form-item label="确认新密码">
        <el-input show-password v-model="editPwdObj.confirmOprPwd"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="editPwdSubmitOnclick"

          >修 改</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import SystemService from "@/request-server/request-services/system-services.js";
export default {
  data() {
    return {
      editPwdObj: {
        oprPwd: "",
        confirmOprPwd: "",
      },
    };
  },
  methods: {
    editPwdSubmitOnclick() {
      let nPwd = this.editPwdObj.oprPwd;
      let cPwd = this.editPwdObj.confirmOprPwd;

      if (typeof nPwd === "undefined" || !nPwd) {
        this.$message.error("请输入新密码");
        return;
      }
      if (typeof cPwd === "undefined" || !cPwd) {
        this.$message.error("请输入确认新密码");
        return;
      }
      if (nPwd !== cPwd) {
        this.$message.error("新密码和确认新密码不一致");
        return;
      }
      SystemService.editOprPwd({ pwd: nPwd })
        .then((res) => {
          this.$message.success("修改密码成功");
        })
        .finally(() => {
          this.editPwdObj.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
